import { brandEnvConfig, getBrand, isXwsy, isXwx, isXwyk } from '@/brandConfig';
import __bl from '@/utils/arms-logger';
import { message, Modal } from 'ant-design-vue';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-BRAND'] = getBrand();

// TODO: 本地调试使用
const getToken = () => {
  if (isXwx || isXwsy) {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50Ijoid19qaWF3YW5qdW4iLCJhY2NvdW50X25hbWUiOiLotL7kuIflhpsiLCJlbWFpbCI6Indfamlhd2FuanVuQHhpd2FuZy5jb20iLCJuYW1lIjoi5Zue6bmP6aOeIiwid29ya2NvZGUiOiJXMDA2Nzk0IiwidGVhY2hlcl9pZCI6MTA4OTk1Nywicm9sZV9pZCI6IjA0ZGY5NGY2OTg0YzQwMzY5ZWM4Yzg4ZDc1ZTUwNTEzIiwiZXhwIjoxNzI2ODkwNTU0LCJpc3MiOiJ4aXdhbmcifQ.l_eF7y6MqWe8iZvWUY4HGXtmOlMWwSiDD1nlVutHD-Q';
  } else if (isXwyk) {
    return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50Ijoid19zaGVudGFvIiwiYWNjb3VudF9uYW1lIjoi55Sa5rabIiwiZW1haWwiOiIiLCJuYW1lIjoi546L5rW36ZyeKOa1i-ivlSkiLCJ3b3JrY29kZSI6IlcxMDIyMDAiLCJ0ZWFjaGVyX2lkIjo4OTIyMSwicm9sZV9pZCI6ImRkMzY1NmZlODIyOTRmODFiOTdkOGE1NjhiZmIyNTg2X3lrIiwiZXhwIjoxNzI2NDUzOTkyLCJpc3MiOiJ4aXdhbmcifQ.NQJh4jKyWBeh7k9PapCvSBYdGHOSOgbIRY8cAlphiAQ';
  }
  return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50Ijoid19qaWF3YW5qdW4iLCJhY2NvdW50X25hbWUiOiLotL7kuIflhpsiLCJlbWFpbCI6Indfamlhd2FuanVuQHhpd2FuZy5jb20iLCJuYW1lIjoi5Zue6bmP6aOeIiwid29ya2NvZGUiOiJXMDA2Nzk0IiwidGVhY2hlcl9pZCI6MTA4OTk1Nywicm9sZV9pZCI6IjA0ZGY5NGY2OTg0YzQwMzY5ZWM4Yzg4ZDc1ZTUwNTEzIiwiZXhwIjoxNzI2ODkwNTU0LCJpc3MiOiJ4aXdhbmcifQ.l_eF7y6MqWe8iZvWUY4HGXtmOlMWwSiDD1nlVutHD-Q';
};

if (import.meta.env.VITE_APP_ENV === 'dev') {
  axios.defaults.headers.common['Authorization'] = getToken();
}

export const loginUrl = `https://sso.saash.vdyoo.com/portal/login/${brandEnvConfig.appid}`;
// import.meta.env.VITE_APP_ENV === 'prod' ? 'https://sso.saash.vdyoo.com/portal/login/A269346936' : 'https://sso.saash.vdyoo.com/portal/login/A965472537';

export interface BaseResponse<T = any> {
  trace_id: number | string;
  res: { source_url: string; introduction: string; timestamp: number; sign: string };
  code?: number;
  msg: string;
  data: T;
}
export interface cancelResponse<V = any> {
  cancel(): void;
  data: Promise<AxiosResponse<BaseResponse<V>>>;
}

const ErrorDic: {
  [key: number]: string;
} = {
  400: '错误的请求',
  401: '未授权，请登录',
  403: '服务器拒绝访问',
  404: '服务器未找到资源',
  408: '请求超时',
  500: '服务器内部错误',
  502: '网关错误',
  503: '服务不可用',
  504: '网关超时'
};
/**
 * 安全的code
 * 0 ｜ 200 无问题
 * 1000 因操作导致的问题
 * 1005 未登录
 * 1009 没有角色
 */
const SUCCESS = 0;
const SAFE_CODE = [200, 1000, 1005, 1009];

class ApiError extends Error {
  constructor(public code = 0, message = '') {
    super(message);
    this.name = this.constructor.name;
  }

  static createBuiltInApiError(statusCode: number) {
    const message = ErrorDic[statusCode];
    if (message) {
      return new ApiError(statusCode, message);
    } else {
      return new ApiError(statusCode, '抱歉出错了');
    }
  }
}

export enum RequestContentType {
  URL_ENCODE = 0,
  JSON = 1,
  FORM_DATA = 2,
  FORM_URLENCODED = 3
}

interface MindRequestConfig {
  withCredentials?: boolean;
  contentType?: RequestContentType;
  signal?: AbortSignal;
}
const formUrlencoded = 'application/x-www-form-urlencoded';
const formDataContentType = 'multipart/form-data';
const defaultRequestConfig: AxiosRequestConfig = {
  timeout: 20000,
  headers: {}
};

function getInstanceConfig(instanceConfig: AxiosRequestConfig): AxiosRequestConfig {
  const { timeout, baseURL, headers } = instanceConfig;
  let mergedHeaders = defaultRequestConfig.headers;
  if (instanceConfig.headers) {
    mergedHeaders = Object.assign({}, defaultRequestConfig.headers, instanceConfig.headers);
  }
  return Object.assign({}, defaultRequestConfig, { timeout: timeout || defaultRequestConfig.timeout, baseURL, mergedHeaders });
}

type InterceptorFulfill<V> = (value: V) => V | Promise<V>;
type InterceptorReject = (error: any) => any;

function interceptLogoutInfo(msg: string) {
  Modal.info({
    title: '温馨提示',
    content: msg,
    onOk: () => {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('hasLogin');
      localStorage.removeItem('Teacher-Desk-X-BRAND'); // 清空选中的品牌
      window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
    }
  });
}

export class AjaxRequest {
  private _axiosInstanceConfig: AxiosRequestConfig;
  public _ajax: AxiosInstance;
  private _options: {
    standard: boolean;
    pureToast: boolean;
  };
  private _concurrencyMap: Map<string, Promise<AxiosResponse<any>>>;

  constructor(
    instanceConfig: AxiosRequestConfig = {},
    options: {
      standard?: boolean;
      pureToast?: boolean;
    } = {
      standard: true,
      pureToast: false
    }
  ) {
    this._options = Object.assign(
      {
        standard: true,
        pureToast: false
      },
      options
    );
    this._concurrencyMap = new Map();

    this._axiosInstanceConfig = getInstanceConfig(instanceConfig);
    this._ajax = axios.create(this._axiosInstanceConfig);

    this._ajax.interceptors.request.use(function (config) {
      config.beginTime = Date.now();

      return config;
    });

    this._ajax.interceptors.response.use(
      (res: AxiosResponse<BaseResponse>) => {
        const { code, msg } = res.data;
        const { url, params } = res.config;
        const isHcconfig = url?.startsWith('/hcconfig/');
        // /hcconfig/ code:0和200是成功   其他的code:0成功
        const isSuccess = res.status === 200 && ((isHcconfig && [0, 200].includes(code!)) || (!isHcconfig && code === 0));

        try {
          const beginTime = res.config.beginTime;
          const time = Date.now() - beginTime;
          if (__bl) {
            __bl.api({
              api: res?.config?.url,
              success: res?.status === 200 && (SAFE_CODE.includes(res?.data?.code) || res?.data?.code === SUCCESS),
              time,
              code: res?.status,
              msg: `code:${res?.data?.code};msg:${res?.data?.msg};params:${JSON.stringify(params)}`,
              begin: beginTime,
              traceId: res?.data?.trace_id
            });
          }

          // 停服逻辑单独处理-方便后续不需要删除
          if (res && res.status === 200) {
            if (code === 10500) {
              // 表示该时间段内停止服务 并跳转到停服页面
              window.location.href = `${window.origin}/crm/index.html#/stopServe?startTime=${res.data.data.start_time}&endTime=${res.data.data.end_time}`;
              // return res.data
            }
          }
          if (res && res.status === 200) {
            if (code === 1007) {
              interceptLogoutInfo(msg);
              return;
            }
            if (res.data) {
              if (!isSuccess) {
                console.error(res);
                if (code === 1005) {
                  interceptLogoutInfo(res?.data?.msg);
                } else if (this._options.standard) {
                  message.error((this._options.pureToast ? '' : '请求失败：') + msg);
                }
              }
              return res;
            } else {
              throw new ApiError(200, '接口返回数据为空');
            }
          } else if (res.status === 401) {
            interceptLogoutInfo(res?.data?.msg);
          } else {
            throw new ApiError(0, '抱歉出错了');
          }
        } catch (err) {
          throw err;
        }
      },
      (error) => {
        let errorInstance = null;
        const beginTime = error.config.beginTime;
        const time = Date.now() - beginTime;
        if (error.response) {
          if (__bl) {
            __bl.api({
              api: error.response.config?.url,
              success: error.response.status === 200 && (error.response.data?.code === 200 || error.response.data?.code === 0),
              time,
              code: error.response.status,
              msg: `code:${error.response.data?.code};msg:${error.response.data?.msg || error.response.data || error.response.statusText}`,
              begin: beginTime,
              traceId: error.response.data?.trace_id
            });
          }
          errorInstance = ApiError.createBuiltInApiError(error.response.status);
        } else {
          let defaultErrorMsg = '抱歉出错了';
          if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message.includes('timeout')) {
            defaultErrorMsg = '请求超时';
          }
          errorInstance = new ApiError(0, `接口${error.config?.url}请求问题;msg: ${error.message || defaultErrorMsg};time:${time}`);
        }

        // throw error
        return Promise.reject(errorInstance);
      }
    );
  }

  registerRequestInterceptor(fulfilled: InterceptorFulfill<AxiosRequestConfig>, rejected: InterceptorReject) {
    if (fulfilled) {
      this._ajax.interceptors.request.use(fulfilled, rejected);
    }
  }

  registerResponseInterceptor<V>(fulfilled: InterceptorFulfill<AxiosResponse<V>>, rejected: InterceptorReject) {
    if (fulfilled) {
      this._ajax.interceptors.response.use(fulfilled, rejected);
    }
  }

  changeAxiosHeaderCommon(headerText: string, value: string): void {
    if (headerText !== '') {
      axios.defaults.headers[headerText] = value;
    }
  }

  async noRepeatGet<V extends BaseResponse>(url: string, params: any, { withCredentials = true }: MindRequestConfig = {}): Promise<AxiosResponse<V>> {
    const resultParams = params || {};
    resultParams.ts = +new Date();
    const key = qs.stringify({
      url,
      params
    });
    if (this._concurrencyMap.has(key)) {
      const result = (await this._concurrencyMap.get(key)) as AxiosResponse<V>;
      if (result.data.code !== 0) {
        throw new ApiError(result.data.code, result.data.msg);
      } else {
        return result;
      }
    } else {
      const pro = this._ajax.get<V, AxiosResponse<V>>(url, {
        params: resultParams,
        withCredentials
      });
      this._concurrencyMap.set(key, pro);
      const result = await pro;
      this._concurrencyMap.delete(key);
      return result;
    }
  }

  async get<V extends BaseResponse>(url: string, params: any, { withCredentials = true }: MindRequestConfig = {}): Promise<AxiosResponse<V>> {
    const resultParams = params || {};
    const httpHeader: any = {};
    const pro = this._ajax.get<V, AxiosResponse<V>>(url, {
      params: resultParams,
      withCredentials,
      headers: httpHeader
    });

    const result = await pro;

    return result;
  }

  async post<V extends BaseResponse>(
    url: string,
    params: any,
    { withCredentials = true, contentType = RequestContentType.JSON }: MindRequestConfig = {}
  ): Promise<AxiosResponse<V>> {
    let resultParams = params;
    if (contentType === RequestContentType.URL_ENCODE) {
      resultParams = qs.stringify(resultParams);
    }
    const httpHeader: any = {};
    if (contentType === RequestContentType.FORM_DATA) {
      httpHeader['content-type'] = formDataContentType;
    }
    if (contentType === RequestContentType.FORM_URLENCODED) {
      httpHeader['Content-Type'] = formUrlencoded;
      resultParams = qs.stringify(params);
    }

    const result = await this._ajax.post<V, AxiosResponse<V>>(url, resultParams, {
      withCredentials,
      headers: httpHeader
    });

    return result;
  }

  // 取消单次请求
  cancelSingleRequest<V extends BaseResponse>(url: string, params: any, { withCredentials = true }: MindRequestConfig = {}): cancelResponse<V> {
    const controller = new AbortController();
    const result = this.get<BaseResponse<V>>(url, params, { withCredentials: true, signal: controller.signal });
    return {
      cancel: controller.abort,
      data: result
    };
  }

  // 取消多次请求
  cancelMoreRequest() {
    let controller: AbortController | null = null;
    return <V extends BaseResponse>(url: string, params: any, { withCredentials = true }: MindRequestConfig = {}): cancelResponse<V> => {
      controller = controller || new AbortController();
      const result = this.get<BaseResponse<V>>(url, params, { withCredentials: true, signal: controller.signal });
      return {
        cancel: controller.abort,
        data: result
      };
    };
  }
}

// const getBaseUrl = () => {
//   if (getBrand() === Brand.Xwx) {
//     return 'https://xuefutest.xue.xiwang.com/';
//   } else if (getBrand() === Brand.Xwyk) {
//     return 'https://xuefutest.wen-su.com/';
//   }
//   return 'https://xuefutest.xue.xiwang.com/';
// };

export default new AjaxRequest({
  baseURL: brandEnvConfig.haichuanDomain
});

export const notStandardAjax = new AjaxRequest(
  {
    baseURL: brandEnvConfig.haichuanDomain
  },
  {
    standard: false
  }
);

export const aiDouTangAjax = new AjaxRequest(
  {
    baseURL: `${brandEnvConfig.haichuanDomain}assistant`,
    timeout: 40000
  },
  {
    standard: true,
    pureToast: true
  }
);

export const aiDouTangMockAjax = new AjaxRequest(
  {
    baseURL: '/mock'
  },
  {
    standard: true,
    pureToast: true
  }
);
